module.exports = __webpack_public_path__ + "static/img/bg_three.3c00f3e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/diagnosis/bg_three.png
// module id = YZAF
// module chunks = 3